import { FC } from "react";

import { Divider, Stack, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";

import OptionalStringList from "../../../../components/Redux/OptionalStringList";
import { ReduxTextField } from "../../../../components/Redux/TextField";
import SettingSection from "../../../../components/SettingSection";
import VersionGuard from "../../../../components/VersionGuard";
import useCurrentClusterSupportsSsh from "../../../../hooks/use-current-cluster-supports-ssh";
import {
  getSettingsFormProperty,
  setSettingsFormError,
  setSettingsFormProperty,
} from "../../../../slices/settings";
import ipPort from "../../../../validators/ipPort";
import sshPrivateKey from "../../../../validators/sshKey";
import { SectionProps } from "../../../routes/components/edit_sections/common";

const Ssh: FC<SectionProps> = ({ readonly, tabValue, refresh }) => {
  const supportsSsh = useCurrentClusterSupportsSsh();
  return (
    <Container component={Paper} maxWidth={false} disableGutters={true}>
      <Stack key={tabValue + refresh} spacing={1} sx={{ m: 3 }}>
        <Typography id={tabValue} variant="h2" sx={{ pt: 2 }}>
          SSH
        </Typography>
        <Divider />

        <VersionGuard
          docsPath="/capabilities/native-ssh-access"
          helpText="Pomerium Zero now supports SSH."
          minVersionRequired="0.30.0"
          enabled={supportsSsh}
        >
          <SettingSection label="SSH Address" docsKey="ssh-address">
            <ReduxTextField
              disabled={readonly}
              setter={setSettingsFormProperty}
              getter={getSettingsFormProperty}
              errorHandler={setSettingsFormError}
              path="sshAddress"
              validator={ipPort}
              fullWidth
            />
          </SettingSection>
          <Divider />

          <SettingSection label="SSH Host Keys" docsKey="ssh-host-keys">
            <OptionalStringList
              multiline
              rows={4}
              path="sshHostKeys"
              disabled={readonly}
              setter={setSettingsFormProperty}
              getter={getSettingsFormProperty}
              errorHandler={setSettingsFormError}
              validator={sshPrivateKey}
            />
          </SettingSection>
          <Divider />

          <SettingSection label="SSH User CA Key" docsKey="ssh-user-ca-key">
            <ReduxTextField
              multiline
              rows={4}
              path="sshUserCaKey"
              disabled={readonly}
              setter={setSettingsFormProperty}
              getter={getSettingsFormProperty}
              errorHandler={setSettingsFormError}
              validator={sshPrivateKey}
            />
          </SettingSection>
        </VersionGuard>
      </Stack>
    </Container>
  );
};
export default Ssh;
